export const scrollSnapButton = () => {
  const nextButton = document.querySelector('.scroll-button.next');
  const prevButton = document.querySelector('.scroll-button.prev');
  if (!nextButton || !prevButton) return;

  const container = nextButton.parentElement.previousElementSibling;
  if (!container) return;

  const cards = container.querySelectorAll('.detail-card');
  if (!cards.length) return;

  // Function to scroll to the next card
  const scrollToNextCard = () => {
    const containerRect = container.getBoundingClientRect();

    for (const card of cards) {
      const cardRect = card.getBoundingClientRect();

      if (cardRect.left > containerRect.left) {
        card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        break;
      }
    }
  };

  // Function to scroll to the previous card
  const scrollToPrevCard = () => {
    const containerRect = container.getBoundingClientRect();

    for (let i = cards.length - 1; i >= 0; i--) {
      const card = cards[i];
      const cardRect = card.getBoundingClientRect();

      if (cardRect.right < containerRect.right) {
        card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'end' });
        break;
      }
    }
  };

  // Attach event listeners to buttons
  nextButton.addEventListener('click', scrollToNextCard);
  prevButton.addEventListener('click', scrollToPrevCard);

  // Event listener for scrolling
  container.addEventListener('scroll', () => {
    const containerRect = container.getBoundingClientRect();
    const isEnd = container.scrollLeft + containerRect.width >= container.scrollWidth;
    const isStart = container.scrollLeft <= 0;

    nextButton.classList.toggle('disabled', isEnd);
    prevButton.classList.toggle('disabled', isStart);
  });

  // Check and update button states based on overflow
  const checkOverflow = () => {
    const containerRect = container.getBoundingClientRect();
    const hasOverflow = container.scrollWidth > containerRect.width;

    nextButton.classList.toggle('active', hasOverflow);
    prevButton.classList.toggle('active', hasOverflow);
  };
  checkOverflow();
  window.addEventListener('resize', checkOverflow);
};
